"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)("#search-input", this).each(function () {
        var $this = (0, _jquery2.default)(this);
        $this.easyAutocomplete({
            url: function url(text) {
                return '/api/services/api/search/Suggest?text=' + encodeURIComponent(text);
            },
            ajaxSettings: {
                dataType: "json",
                contentType: "application/json",
                method: "POST",
                data: {}
            },
            listLocation: "result",
            list: {
                onChooseEvent: function onChooseEvent() {
                    $this.closest('form').submit();
                }
            },

            requestDelay: 500 // prevent multirequest to server
        });
    });
};

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
//import L from "linksoft/utils/localize"

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/autocomplete.js
// module id = 924
// module chunks = 0